export const SubFormTypeEditorCSS = {
	wrapper: 'c-SubFormTypeEditor__wrapper',
	grid: 'c-SubFormTypeEditor__grid',
};

export const Style = {
	[SubFormTypeEditorCSS.wrapper]: {
		'container-type': 'inline-size',
	},
	[SubFormTypeEditorCSS.grid]: {
		display: 'grid',
		'grid-template-columns': 'repeat(2, minmax(0, 1fr))',
		gap: '5px',
	},
};
